import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJustworksLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 630 630",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 630,
			height: 630,
			fill: "#1E97FF"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_59_9222)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M286.09 378.52C280.61 375.01 274.73 371.98 269.72 367.89C257.58 357.97 252.79 344.1 250.63 329.15C250.49 328.15 252.06 326.15 253.1 325.89C266.23 323.18 279.41 320.71 293.04 318.09C293.77 322.16 294.04 325.77 295.04 329.18C299.5 344.35 311.29 350.4 325.28 343.9C332.02 340.78 334.64 334.83 334.65 327.63C334.65 289.21 334.65 250.797 334.65 212.39C334.65 200.2 334.65 200.19 346.84 200.13C356.15 200.08 365.46 200.18 374.77 200C378.12 199.94 379.58 200.93 379.57 204.51C379.49 243.92 379.67 283.33 379.39 322.74C379.32 333.87 377.39 344.84 372.44 355.07C367.08 366.14 358.38 373.3 346.91 377.35C346.055 377.708 345.223 378.118 344.42 378.58C337.42 379.58 330.35 381.58 323.35 381.38C310.94 381.1 298.54 379.55 286.09 378.52Z",
				fill: "#010102"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M286.09 378.52C298.54 379.52 310.98 381.1 323.45 381.38C330.45 381.54 337.45 379.59 344.52 378.58C354.52 378.65 364.46 378.83 374.43 378.71C377.93 378.71 379.43 379.51 379.43 383.41C379.237 397.203 379.237 410.997 379.43 424.79C379.49 428.87 377.89 429.79 374.12 429.79C334.727 429.67 295.337 429.67 255.95 429.79C251.68 429.79 250.1 428.71 250.16 424.21C250.36 410.92 250.23 397.63 249.98 384.34C249.89 380.07 251.21 378.58 255.66 378.69C265.82 378.93 275.94 378.61 286.09 378.52Z",
				fill: "#F8FCFC"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_59_9222",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 129.67,
				height: 229.78,
				fill: "white",
				transform: "translate(250 200)"
			})
		}) })
	]
});
export { SvgJustworksLogo as ReactComponent };
